/** @jsx jsx */
import {jsx, css} from '@emotion/react'
// eslint-disable-next-line no-unused-vars
import React, {useEffect, useState} from 'react'
import Hero from './Hero'
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Footer from './Footer'
import {EVENTS, logDplWithAppParams} from '../../../util/dpl'
import {getCountry} from '../../../util/getCountry'
import {logSgc} from '../../../util/extensionMetadata'
import Unsupported from './Unsupported'
import {colors} from '../../../constants'
import logAmplitude from '../../../util/amplitude'
import SpFavicons from './SpFavicons'
import {getUrlParameterByName} from '../../../util/url'
import {iOSAppStoreLink} from '../../../util/vanishAppDownloadLinks'

const PrivateaiV1 = ({os, browser, experimentId, languageCode = `en`}) => {
    const isMobile = new Set(['ios', 'android']).has(os)

    const [showPage, setShowPage] = useState(false)

    useEffect(() => {
        if (!experimentId) return
        logAmplitude(experimentId)
        logSgc()
        const shouldRedirect = Boolean(getUrlParameterByName('redirect')) && isMobile
        if (shouldRedirect) {
            logDplWithAppParams(EVENTS.StartpageAppRedirect, {
                os,
                country: getCountry(),
                experiment: experimentId,
            }).then(() => {
                if (os === 'ios') {
                    window.location.href = iOSAppStoreLink
                }
                // setTimeout delays showing the page content so user just sees white screen before being
                // redirected to the app (in an attempt to make the transition smoother)
                // still, we wanna show the page eventually if the redirect doesnt happen, so this here is the fallback
                setTimeout(() => {
                    setShowPage(true)
                }, 2000)
            })
        } else {
            setShowPage(true)
            logDplWithAppParams(EVENTS.StartpageAppPageLoad, {
                os,
                country: getCountry(),
                experiment: experimentId,
            })
        }
    }, [experimentId, isMobile, os])

    const getHero = () => {
        return (
            <div
                className="hero-wrapper"
                css={css`
                    .mobile {
                        display: none;
                    }
                    @media (max-width: 480px) {
                        .desktop {
                            display: none;
                        }
                        .mobile {
                            display: block;
                        }
                    }
                `}
            >
                <div className="desktop">
                    <Unsupported os={os} browser={browser} experimentId={experimentId} languageCode={languageCode} />
                </div>
                <div className="mobile">
                    <Hero experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                </div>
            </div>
        )
    }

    return (
        <>
            <SpFavicons />
            <div
                className="PrivateAI-v1"
                css={css`
                    width: 100%;
                    overflow: hidden;
                    visibility: ${showPage ? 'visible' : 'hidden'};
                    p, span {
                        color ${colors.black} !important;
                    }
                `}
            >
                {getHero()}
                <div
                    css={css`
                        @media (min-width: 481px) {
                            display: none;
                        }
                    `}
                >
                    <Section1 experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                    <Section2 experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                    <Section3 experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                    <Section4 experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                    <Footer experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                </div>
            </div>
        </>
    )
}

export default PrivateaiV1
